export const issuanceMonitorWidget = {
    minYear: 2011,
    dealsMinYear: 2021,
    itemsOnPage: 10
};
